import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

import { ContentSchemaRender } from "scmp-app/components/schema-render/content";

export const Container = styled.div`
  position: relative;

  max-inline-size: 446px;
  margin-block-start: 46.13px;
  margin-inline: auto;

  ${props => props.theme.breakpoints.up("desktop")} {
    grid-column: 4 / span 6;

    max-inline-size: unset;
    margin-block-start: 64px;

    border-radius: 20px;
  }
`;

export const StyledIconSayIt = styled.img`
  inline-size: 234px;
  block-size: 294px;

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    inline-size: 293px;
    block-size: 367px;
  }
`;

export const StyledIconSayItContainer = styled.div`
  display: flex;
  justify-content: center;

  margin-block-end: -13px;

  ${props => props.theme.breakpoints.up("desktop")} {
    grid-row: 1 / span 1;
    grid-column: 2 / span 3;

    position: absolute;
    inset-block-start: -64px;
    inset-inline-start: calc(-234px + 40px - 8px);
    z-index: 1;

    margin-block-end: 0;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    inset-inline-start: calc(-293px + 56px - 8px);
  }
`;

export const StyledVocabBoxContainer = styled.div`
  inset-block-start: 6px;

  block-size: fit-content;

  border: 2px solid #000000;
  border-radius: 16px;
`;

export const StyledVocabBox = styled.div`
  position: relative;
  inset-block-start: 8px;
  inset-inline-start: -8px;
  z-index: -1;

  display: flex;
  flex-direction: column;
  row-gap: 28px;

  padding-block: 32px;
  padding-inline: 32px;

  border-radius: 16px;

  background-color: #f1fccf;

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block: 56px;
    padding-inline: 40px;

    border-radius: 20px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    padding-block: 72px;
    padding-inline: 56px;
  }
`;

export const StyledVocab = styled.div`
  display: flex;
  flex-direction: column;

  ${props => props.theme.breakpoints.up("desktop")} {
    flex-direction: row;

    column-gap: 16px;
  }
`;

export const StyledText = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  font-family: ${fontFredoka};

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    row-gap: 12px;
  }
`;

export const StyledTermAndTranslation = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  align-items: center;

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    column-gap: 16px;
  }
`;

export const StyledTerm = styled.div`
  color: #333333;
  font-weight: 600;
  font-size: 26px;
  line-height: 26px;

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    font-weight: 700;
    font-size: 28px;
    line-height: 32px;
  }
`;

export const StyledTranslation = styled.div`
  font-weight: 700;
  font-size: 22px;
  line-height: 22px;

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    font-size: 28px;
    line-height: 32px;
  }
`;

export const StyledContentSchemaRender = styled(ContentSchemaRender)`
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    font-size: 24px;
    line-height: 32px;
  }
`;
